// ============================================================================
// FORMATTING HELPERS
// ============================================================================

const priceFormatter = new Intl.NumberFormat('sv-SE', {
  style: 'currency',
  currency: 'SEK',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
})

/**
 * Format a price given in öre (integer) as a Swedish currency string.
 * Example: 19900 -> "199 kr"
 */
export function formatPrice(ore: number): string {
  return priceFormatter.format(ore / 100)
}

export type Condition = 'new' | 'like_new' | 'good' | 'fair'

const CONDITION_LABELS: Record<Condition, string> = {
  new: 'Nyskick',
  like_new: 'Nästan nytt',
  good: 'Bra skick',
  fair: 'Sliten',
}

export function conditionLabel(condition: string): string {
  return CONDITION_LABELS[condition as Condition] ?? condition
}

export type OrderStatus = 'pending' | 'paid' | 'shipped' | 'cancelled'

const ORDER_STATUS_LABELS: Record<OrderStatus, string> = {
  pending: 'Väntar på betalning',
  paid: 'Betald',
  shipped: 'Skickad',
  cancelled: 'Avbruten',
}

export function orderStatusLabel(status: string): string {
  return ORDER_STATUS_LABELS[status as OrderStatus] ?? status
}

export function formatDate(value: string): string {
  return new Date(value).toLocaleDateString('sv-SE', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  })
}
